import React from "react";

//////////////////////////////////////
////  GET PARAMETERS FROM IFRAME  ////
let getParamValue = function(paramName){
    var url = window.location.search.substring(1); //get rid of "?" in querystring
    var qArray = url.split('&'); //get key-value pairs
    for (var i = 0; i < qArray.length; i++){
        var pArr = qArray[i].split('='); //split key and value
        if (pArr[0] === paramName) {
            return pArr[1]; //return value
        }
    }
}
var athlete_id = undefined;
var portal_id  = undefined; // portal id comes from url query string
var url_users_email = undefined;
var mktplc_prog_id  = undefined; // "25bf7a60-9c94-11ea-826f-89faa507940c"
//http://localhost:3000/login?portal_id=148955cc-a6ae-402b-9639-1f65be8d9ed6&email=klu@kevinlu.com&mktplc_prog_id=25bf7a60-9c94-11ea-826f-89faa507940c

export const WhiteLabel = () => {
    //console.log("------  WhiteLabel Props called  --------");
    var w = window.location.host;
    //console.log("WHITE LABEL window host: " + w);

    var tmp_url_str = window.location.pathname;
    //console.log("tmp_url_str: " + tmp_url_str);
    var current_sub = tmp_url_str.split('.com/')[0];

    //if(current_sub === "/login") {
    athlete_id      = getParamValue('aid');
    portal_id       = getParamValue('portal_id'); // used for single signon from PH
    url_users_email = getParamValue('email'); // used for single signon from PH
    mktplc_prog_id  = getParamValue('mktplc_prog_id'); // used to view the summary of a program in the marketplace

    var company_name;
    var company_id;
    var company_primary_color       = "000000"; // hex value (hide #, doesnt work with url str)
    var company_secondary_color     = "999999"; // hex value
    var company_primary_btn_color   = "a2e01c"; // TS green
    var company_close_btn_color     = "aaa";
    var s3_bucket_name;
    var s3_bucket_url               = "ts-white-label-website.s3-us-west-2.amazonaws.com"; // AWS url NEVER changes

    // This is ghetto and temporary //
    //w === "localhost:3001" || w === "localhost:3001" ||
    if(w === "localhost:3001" || w === "localhost:3001" || w === "asp-athlete.trainingslate.com") {
            //// DEFAULT TO ASP  ////
            company_name              = "Accelerate Sports Performance";;
            company_id                = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";
            company_primary_color     = "d23720"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name            = "asp";
            //company_primary_btn_color = "333"
    } else if (w === "ateam-athlete.trainingslate.com") {
            company_name            = "A Team Health & Fitness";
            company_id              = "e28b5e77-f23e-4d29-8bc0-3ad41a87ab82";
            company_primary_color   = "145ac1"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "ateam";
    } else if (w === "battle-athlete.trainingslate.com") {
            company_name            = "Battle Tested Fitness";
            company_id              = "ea954de1-6e6f-11ea-a519-91577bfa52fe";
            s3_bucket_name          = "battle";
    } else if(w === "creig-nakano-athlete.trainingslate.com") {
            company_name            = "Nakano Human Performance";
            company_id              = "80c28c57-ca1e-4f08-b4fb-e7663ce7f253";
            company_primary_color   = "a3de35"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "creig-nakano";

    } else if (w === "fitlab-athlete.trainingslate.com") {
            company_name            = "Fitlab";
            company_id              = "ba8039a1-75d9-11ea-9773-5105bbfa13a0";
            company_primary_color   = "232364"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "fitlab";
    } else if(w === "g7-athlete.trainingslate.com") {
            company_name            = "G7";
            company_id              = "c84b2dd4-665e-4c78-be36-72d734a4f30b";
            s3_bucket_name          = "g7";
    } else if(w === "gi-athlete.trainingslate.com") {
            company_name            = "Gym Integrity";
            company_id              = "d842b7c5-cffd-49d3-992f-637b2221d3e4";
            s3_bucket_name          = "gi";

    } else if(w === "healthhub-athlete.trainingslate.com") {
            company_name            = "Health Hub";
            company_id              = "8d126130-eefd-11ea-a7f1-f54779db8de1";
            s3_bucket_name          = "healthhub";
    } else if(w === "fueledbyfour-athlete.trainingslate.com") {
            company_name            = "FueledByFour";
            company_id              = "a9ee03e2-bb4f-4d6b-b718-ee80f5d6cfd0";
            s3_bucket_name          = "fueledbyfour";
    } else if (w === "jcee-athlete.trainingslate.com") {
            company_name            = "JCEE Fitness";
            company_id              = "78e4f760-6e72-11ea-adb0-110a6e5d34e7";
            s3_bucket_name          = "jcee";

    } else if(w === "localhost:3001" || w === "localhost:3001" || w === "posture-athlete.trainingslate.com") {
            company_name              = "Posture Health";
            company_id                = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
            company_primary_color     = "1ab1dc"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name            = "posture";
            company_primary_btn_color = "1ab1dc"; // not req'd
    } else if(w === "pt-athlete.trainingslate.com") {
            company_name            = "Physical Therapt";
            company_id              = "0274fcde-a85b-4e04-bcb2-ad76e34847f1";
            company_primary_color   = "536a8c"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "pt";
    } else {
            company_name            = "Training Slate";
            company_id              = "6d226cf8-fedd-4e72-b892-38dac02aedbc";
            company_primary_color   = "a3de35"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "ts";
    }

    document.title                    = company_name + " Athlete"; // Set the HTML Tab Title
    var aws_html_assets_url           = "https://"+s3_bucket_url+"/"+s3_bucket_name+"/html_assets/";
    var aws_client_athlete_assets_url = "https://"+s3_bucket_url+"/"+s3_bucket_name+"/athlete_images/";

    var company_logo       = "logo.png";       // header logo
    var company_login_logo = "logo_sq.png";   // login logo
    ////  HTML FAVICONS  ////
    //var html_manifest      = document.getElementById('html_manifest');
    var html_apple_touch   = document.getElementById('html_apple_touch');
    var html_favicon_32    = document.getElementById('html_favicon_32');
    var html_favicon_16    = document.getElementById('html_favicon_16');
    var html_safari_pin    = document.getElementById('html_safari_pin');

    //html_manifest.href    = aws_html_assets_url + "manifest.json";
    html_apple_touch.href = aws_html_assets_url + "apple-touch-icon.png";
    html_favicon_32.href  = aws_html_assets_url + "favicon-32x32.png";
    html_favicon_16.href  = aws_html_assets_url + "favicon-16x16.png";
    html_safari_pin.href  = aws_html_assets_url + "safari-pinned-tab.svg";

    if(company_name != undefined)            sessionStorage.setItem('company_name', company_name);
    if(company_id != undefined)              localStorage.setItem('company_id', company_id);
    if(company_logo != undefined)            sessionStorage.setItem('company_logo', company_logo);
    if(company_login_logo != undefined)      sessionStorage.setItem('company_login_logo', company_login_logo);
    if(company_primary_color != undefined)   sessionStorage.setItem('company_primary_color', company_primary_color);
    if(company_secondary_color != undefined) sessionStorage.setItem('company_secondary_color', company_secondary_color);
    if(s3_bucket_name != undefined)          sessionStorage.setItem('s3_bucket_name', s3_bucket_name);
    if(s3_bucket_url != undefined)           sessionStorage.setItem('s3_bucket_url', s3_bucket_url);

    // Get saved data from sessionStorage
    // let company_name = sessionStorage.getItem('company_name');
    var white_label = {};
    white_label.athlete_id = athlete_id;
    white_label.portal_id  = portal_id;
    white_label.url        = w;
    white_label.url_users_email = url_users_email;
    white_label.mktplc_prog_id  = mktplc_prog_id;
    white_label.company_id      = company_id;
    white_label.company_primary_btn_color = "#"+company_primary_btn_color;
    white_label.company_close_btn_color   = "#"+company_close_btn_color;
    white_label.aws_athlete_dashboard_images_url = aws_client_athlete_assets_url+"/";
    ////  Used for personal cover images for companies that have an Athlete Marketplace  ////
    white_label.aws_custom_athlete_assets_dashboard_url = aws_client_athlete_assets_url + "dashboard/";
    ////  For companies that don't have a marketplace and use general cover images on the dashboard (provided by TS)  ////
    white_label.aws_general_athlete_assets_url          = "https://ts-white-label-app.s3.us-west-2.amazonaws.com/athlete_images/dashboard/";

    return white_label;
}



// WEBPACK FOOTER //
// ./src/utils/WhiteLabelProps.js